import React from "react";

export default ({ value }) => {
  if (typeof value === "undefined" || value === null) {
    return null;
  }

  return <div className="number-renderer">{value}</div>;
};
